// EVKT and ICE VKT
// Distance traveled for Electric and ICE (Combustion Engine) Vehicles

import { zipWith } from 'lodash';
import { createSelector } from 'reselect';

import {
  getVKTByOwner
} from '../vehicleDistanceTraveled';

import {
  getVehicleElectricStock
} from '../vehicleStock'

import {
  getUtilizationSeries
} from '../utilization';

const BILLION = Math.pow(10, 9); // adjust for BILLION kilometers

// Billion EVKT Traveled
export const getElectricDistanceTraveled = createSelector([
  getVehicleElectricStock,
  getUtilizationSeries,
  getVKTByOwner
],
  (vehicleStockSeries, utilizationSeries, allVKTSeries) => {

    return zipWith(
      vehicleStockSeries,
      utilizationSeries,
      allVKTSeries, // just for bus metro
      (stock, utilization, allVKT) => {
        return {
          autoRickshaw: {
            commercial: stock.autoRickshaw.commercial * utilization.autoRickshaw.commercial / BILLION,
          },
          car: {
            commercial: stock.car.commercial * utilization.car.commercial / BILLION,
            private: stock.car.private * utilization.car.private / BILLION,

          },
          publicTransit: {
            bus: stock.publicTransit.bus * utilization.publicTransit.bus / BILLION,
            metro: allVKT.publicTransit.metro
          },
          twoWheel: {
            commercial: stock.twoWheel.commercial * utilization.twoWheel.commercial / BILLION,
            private: stock.twoWheel.private * utilization.twoWheel.private / BILLION,
          }
        }
      }
    )
  }
)

// Market Size!Billion Ice VKT Traveled
export const getICEDistanceTraveled = createSelector([
  getVKTByOwner,
  getElectricDistanceTraveled,
],
  (totalDistanceSeries, electricSeries) => {
    return zipWith(
      totalDistanceSeries,
      electricSeries,
      (totalDistance, electricDistance) => {
        return {
          autoRickshaw: {
            commercial: totalDistance.autoRickshaw.commercial - electricDistance.autoRickshaw.commercial,
          },
          car: {
            commercial: totalDistance.car.commercial - electricDistance.car.commercial,
            private: totalDistance.car.private - electricDistance.car.private,

          },
          publicTransit: {
            bus: totalDistance.publicTransit.bus - electricDistance.publicTransit.bus,
          },
          twoWheel: {
            commercial: totalDistance.twoWheel.commercial - electricDistance.twoWheel.commercial,
            private: totalDistance.twoWheel.private - electricDistance.twoWheel.private,
          }
        }
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/vehicleDistanceTraveled/byFuel.ts